import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import ComboHeader from "../../components/ComboHeader/ComboHeader";
import NativeObject from "../../components/NativeObject/NativeObject";
import Card from "../Cards/Card";

function KpiCard({
  app,
  KPITitle,
  iconId,
  percentageId,
  greyValueId,
  valueId,
  customStyle,
  isMobile,
  tooltip,
}) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (KPITitle) {
      setLoading(false);
    }
  }, [KPITitle]);
  return (
    <Card
      style={{
        width: "100%",
        padding: "10px",
        justifyContent: "center",
        ...customStyle,
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          {/* TITULO */}
          <ComboHeader
            reference={{
              title: {
                id: KPITitle.id,
                hard: KPITitle.hardTitle,
              },
            }}
            tooltip={tooltip}
          />
        </div>

        <div
          style={{
            height: "100%",
            width: isMobile ? null : "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: isMobile ? null : "center",
          }}
        >
          {/*CONTAINER VALUES*/}
          <div
            style={{
              width: isMobile ? "90%" : "75%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className={"containerKpiValueBoldUnique"}>
              {/* VALOR PRINCIPAL */}
              <NativeObject
                className="kpiValueBold"
                app={app}
                key={valueId}
                reference={{ id: valueId }}
              />
            </div>
          </div>
        </div>

        {percentageId && (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            {/* INDICADOR PORCENTAGEM */}
            <NativeObject
              app={app}
              key={percentageId}
              reference={{ id: percentageId }}
            />
          </div>
        )}
      </div>
    </Card>
  );
}

KpiCard.defaultProps = {
  app: null,
  KPITitle: {},
  iconId: null,
  percentageId: null,
  greyValueId: null,
  valueId: null,
};

KpiCard.propTypes = {
  app: PropTypes.object,
  KPITitle: PropTypes.object,
  iconId: PropTypes.string,
  percentageId: PropTypes.string,
  greyValueId: PropTypes.string,
  valueId: PropTypes.string,
};

export default KpiCard;
